// web app's Firebase configuration

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_APP_ID,
// };
// export default firebaseConfig;

const firebaseConfig = {
  apiKey: "AIzaSyDy65UZYPywErqQVwEPSYv1RKZKSCl9c3A",
  authDomain: "learning-platform-projec-a1749.firebaseapp.com",
  projectId: "learning-platform-projec-a1749",
  storageBucket: "learning-platform-projec-a1749.appspot.com",
  messagingSenderId: "578257030748",
  appId: "1:578257030748:web:00e51275becbd08c4ce099",
};
export default firebaseConfig;
